export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_17.39801ff4.jpg";